
import Promise from 'promise-polyfill';

export function allImagesLoaded(pathsArray, maxTimeForEachImageToLoad = 20000) {
	
	let promiseArray = [],
		maxAllowedLoadingTimeBeforeReject = maxTimeForEachImageToLoad * pathsArray.length;
		
	pathsArray.forEach( (path) => {
		promiseArray.push(imageLoaded(path));
	});
	
	return new Promise( (resolve, reject) => {

		let loadingTimeout = setTimeout( () => {
			reject();
		}, maxAllowedLoadingTimeBeforeReject);

		Promise.all(promiseArray).then(paths => {
			clearTimeout(loadingTimeout);
			resolve(paths);
		});
	});
}

export default function imageLoaded(path) {

	return new Promise(resolve => {

		const img = new Image();
		
		img.onload = () => resolve({
			path, status: 'ok'
		});
		img.onerror = () => resolve({
			path, status: 'error'
		});

		img.src = path;
	});	
}